var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.classifiers.attributes.filter(attribute => attribute.dimensions_id == _vm.dimension.id)),function(attribute){return _c('AttributeView',{key:attribute.id,attrs:{"attribute":attribute,"classifiers":_vm.classifiers,"userData":_vm.userData,"isOpen":_vm.isOpen}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }